import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import NameField from 'components/forms/new/formikFormFields/NameField';

/**
 * Max channel count input for the ACS profile form.
 *
 * The value is owned by the page's modalState, like the other ACS fields, so
 * this deliberately does not go through a Formik <Field>: a Formik field would
 * validate its own copy of the value, which the page's onChange never updates.
 */
const ACSMaxChannelField = ({ darkMode, error, showError, ...props }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!error && showError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Max Channel Count{' '}
                        <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Set the maximum number of concurrent channels.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <NameField
                            id="maxChannel"
                            name="maxChannel"
                            darkMode={darkMode}
                            error={showError ? error : ''}
                            {...props}
                        />
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Set the maximum number of concurrent channels."
                        ariaLabel="acs-max-channel-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ACSMaxChannelField;
